
import { Annotation } from '../../../types/annotation';
import { cn } from '../lib/utils'
import { Clock, User } from 'lucide-react';
import { formatDistanceToNow } from '../../utilities/date';
import { formatTime } from '../../utilities/time';
import moment from 'moment';

interface AnnotationItemProps {
  annotation: Annotation;
  onClick: (id: string) => void;
  isActive: boolean;
}


export function AnnotationItem({ annotation, onClick, isActive }: AnnotationItemProps) {
  return (
    <div 
      className={cn(
        "tw-p-4 tw-border tw-rounded-lg tw-cursor-pointer tw-transition-colors",
        isActive ? "tw-bg-annotate-accent" : "tw-hover:tw-bg-annotate-accent/50"
      )}
      onClick={() => onClick(annotation.id)}
      style={{ borderLeftColor: annotation.color, borderLeftWidth: '4px' }}
    >
      <div className="tw-font-medium tw-mb-1">{annotation.text}</div>
      <div className="tw-text-sm tw-text-muted-foreground tw-mb-2">
        {moment(annotation.startTime).format('h:mm:ss A')} - {moment(annotation.endTime).format('h:mm:ss A')}
      </div>
      {annotation.comments && (
        <div className="tw-text-sm tw-text-muted-foreground tw-line-clamp-2 tw-mb-3">
          {annotation.comments}
        </div>
      )}
      <div className="tw-flex tw-items-center tw-justify-between tw-text-xs tw-text-muted-foreground">
        <div className="tw-flex tw-items-center tw-gap-1">
          <User className="tw-h-3 tw-w-3" />
          <span>{annotation.createdBy}</span>
        </div>
        <div className="tw-flex tw-items-center tw-gap-1">
          <Clock className="tw-h-3 tw-w-3" />
          <span>{formatDistanceToNow(annotation.createdAt)}</span>
        </div>
      </div>
    </div>
  );
}